<template>
  <ion-list>
    <ion-item button="true" detail="false" @click="onDelete" color="danger">
      <ion-icon slot="start" name="trash"></ion-icon>
      <span>Delete</span>
    </ion-item>
  </ion-list>
</template>

<script>
export default {
  name: "PhotoActionsPopover",
  props: ["file", "onDelete"],
  methods: {
    onClose() {
      return this.$ionic.popoverController.dismiss();
    }
  }
};
</script>
